'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const React = require('react');
const theme_Animation = require('../../../theme/Animation.cjs.js');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
const styleEncapsulation = require('@zapier/style-encapsulation');
const utils_uniqueId = require('../../../utils/uniqueId.cjs.js');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const colorVariations = {
  gray: {
    base: {
      borderColor: theme_Colors.Colors.GrayWarm7
    },
    check: {
      borderColor: theme_Colors.Colors.Blue3
    },
    hover: {
      borderColor: theme_Colors.Colors.Blue3
    },
    focus: {
      backgroundColor: theme_Colors.Colors.Blue3,
      borderColor: theme_Colors.Colors.Blue3
    }
  },
  white: {
    base: {
      borderColor: theme_Colors.Colors.PrimeWhite
    },
    check: {
      borderColor: theme_Colors.Colors.PrimeWhite
    },
    hover: {
      borderColor: theme_Colors.Colors.PrimeWhite
    },
    focus: {
      backgroundColor: theme_Colors.Colors.PrimeWhite,
      borderColor: theme_Colors.Colors.PrimeWhite
    }
  }
};
const Styles = styleEncapsulation.labelStyles("Indicator", {
  input: (props) => [
    Object.assign(Object.assign({}, styleMixins_reset.baseReset), {
      position: "relative",
      appearance: "none",
      display: "inline-block",
      borderStyle: "solid",
      borderWidth: 2,
      borderRadius: "50%",
      width: 10,
      height: 10,
      cursor: "pointer",
      transitionDuration: theme_Animation.Animation.transitionDuration,
      transitionProperty: "border-width, border-color",
      transitionTimingFunction: theme_Animation.Animation.transitionTimingFunction,
      // creates a ring around the radio button for the focus state
      "&::before": {
        position: "absolute",
        height: 16,
        width: 16,
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        borderRadius: "50%",
        pointerEvents: "none",
        content: '""',
        opacity: 0,
        transitionDuration: theme_Animation.Animation.transitionDuration,
        transitionProperty: "opacity",
        transitionTimingFunction: theme_Animation.Animation.transitionTimingFunction
      },
      "&:checked": {
        borderWidth: 5
      },
      "&:focus": {
        "&::before": {
          opacity: 0.25
        }
      },
      "&:hover": {
        borderWidth: 5
      }
    }),
    styleEncapsulation.withModifier(props.color, {
      borderColor: colorVariations[props.color].base.borderColor,
      "&::before": {
        backgroundColor: colorVariations[props.color].focus.backgroundColor
      },
      "&:checked": {
        borderColor: colorVariations[props.color].check.borderColor
      },
      "&:focus": {
        borderColor: colorVariations[props.color].focus.borderColor
      },
      "&:hover": {
        borderColor: colorVariations[props.color].hover.borderColor
      }
    })
  ],
  root: (props) => [
    Object.assign(Object.assign({}, styleMixins_reset.boxSizing), { display: "grid", gap: 6, gridTemplateColumns: `repeat(${props.count}, 10px)` })
  ]
});
const Indicator = (props) => {
  const { "aria-label": ariaLabel, count, noun = "page", onChangeIndex, selectedIndex } = props;
  const [name] = React.useState(utils_uniqueId.uniqueId("Indicator-"));
  const handleOnChange = ({ target }) => {
    const { value } = target;
    const index = parseInt(value, 10);
    onChangeIndex(index);
  };
  return react.jsx("div", { "aria-label": ariaLabel, css: Styles.root(props), role: "radiogroup", "data-zds": true }, Array.from({ length: count }).map((_, i) => react.jsx("input", { "aria-label": `${noun} ${i + 1}`, checked: i === selectedIndex, css: Styles.input(props), key: `bubble-${i}`, name, onChange: handleOnChange, type: "radio", value: i, "data-zds": true })));
};

exports.Indicator = Indicator;
//# sourceMappingURL=Indicator.cjs.js.map
